var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinnerWithCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My account Page"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1142,
    transform: "translate(-113 -607)",
    fill: "#020529"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "div.card",
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -58,
    y: -101,
    width: 1311,
    height: 602,
    rx: 10,
    fill: "white",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1410105434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004026"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 248",
    x: -29,
    y: -23,
    width: 1216,
    height: 109,
    rx: 10,
    fill: "#020529"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22. Eat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9375 2.8125V6.1875C21.9375 6.48587 21.819 6.77202 21.608 6.983C21.397 7.19397 21.1109 7.3125 20.8125 7.3125H15.1875L14.3212 8.17875C14.3004 8.19949 14.2739 8.21372 14.2451 8.21969C14.2162 8.22567 14.1863 8.22314 14.1589 8.21241C14.1315 8.20169 14.1078 8.18323 14.0907 8.15927C14.0735 8.13532 14.0638 8.10691 14.0625 8.0775V2.8125C14.0625 2.51413 14.181 2.22798 14.392 2.017C14.603 1.80603 14.8891 1.6875 15.1875 1.6875H20.8125C21.1109 1.6875 21.397 1.80603 21.608 2.017C21.819 2.22798 21.9375 2.51413 21.9375 2.8125Z",
    fill: "#EE7231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3125 1.125V4.5C16.3125 4.79837 16.431 5.08452 16.642 5.2955C16.853 5.50647 17.1391 5.625 17.4375 5.625H23.0625L23.9288 6.49125C23.9496 6.51199 23.9761 6.52622 24.0049 6.53219C24.0338 6.53817 24.0637 6.53564 24.0911 6.52491C24.1185 6.51419 24.1422 6.49573 24.1593 6.47177C24.1765 6.44782 24.1862 6.41941 24.1875 6.39V1.125C24.1875 0.826631 24.069 0.540483 23.858 0.329505C23.647 0.118526 23.3609 0 23.0625 0L17.4375 0C17.1391 0 16.853 0.118526 16.642 0.329505C16.431 0.540483 16.3125 0.826631 16.3125 1.125Z",
    fill: "#F8CF6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.25 3.375C20.5607 3.375 20.8125 3.12316 20.8125 2.8125C20.8125 2.50184 20.5607 2.25 20.25 2.25C19.9393 2.25 19.6875 2.50184 19.6875 2.8125C19.6875 3.12316 19.9393 3.375 20.25 3.375Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18 3.375C18.3107 3.375 18.5625 3.12316 18.5625 2.8125C18.5625 2.50184 18.3107 2.25 18 2.25C17.6893 2.25 17.4375 2.50184 17.4375 2.8125C17.4375 3.12316 17.6893 3.375 18 3.375Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.5 3.375C22.8107 3.375 23.0625 3.12316 23.0625 2.8125C23.0625 2.50184 22.8107 2.25 22.5 2.25C22.1893 2.25 21.9375 2.50184 21.9375 2.8125C21.9375 3.12316 22.1893 3.375 22.5 3.375Z",
    fill: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.99995 28.0411C8.97757 27.8919 8.89684 27.7577 8.77553 27.668C8.65422 27.5784 8.50225 27.5406 8.35307 27.5629C8.20389 27.5853 8.0697 27.666 7.98004 27.7874C7.89037 27.9087 7.85257 28.0606 7.87495 28.2098L8.12807 29.8129H3.12182L3.37495 28.2098C3.39732 28.0606 3.35952 27.9087 3.26986 27.7874C3.18019 27.666 3.046 27.5853 2.89682 27.5629C2.74764 27.5406 2.59567 27.5784 2.47436 27.668C2.35305 27.7577 2.27232 27.8919 2.24995 28.0411L1.12495 35.3536C1.11386 35.4274 1.11744 35.5028 1.13547 35.5752C1.15351 35.6477 1.18564 35.716 1.23004 35.776C1.27443 35.8361 1.33023 35.8868 1.39423 35.9253C1.45824 35.9638 1.5292 35.9894 1.60307 36.0004C1.67694 36.0115 1.75227 36.0079 1.82475 35.9899C1.89724 35.9719 1.96546 35.9397 2.02553 35.8953C2.0856 35.8509 2.13633 35.7952 2.17484 35.7311C2.21334 35.6671 2.23886 35.5962 2.24995 35.5223L2.60432 33.1879H8.64557L8.99995 35.5223C9.01103 35.5962 9.03655 35.6671 9.07505 35.7311C9.11356 35.7952 9.16429 35.8509 9.22436 35.8953C9.28443 35.9397 9.35265 35.9719 9.42514 35.9899C9.49762 36.0079 9.57295 36.0115 9.64682 36.0004C9.72069 35.9894 9.79165 35.9638 9.85566 35.9253C9.91966 35.8868 9.97546 35.8361 10.0199 35.776C10.0643 35.716 10.0964 35.6477 10.1144 35.5752C10.1324 35.5028 10.136 35.4274 10.1249 35.3536L8.99995 28.0411ZM2.77307 32.0629L2.94745 30.9379H8.30245L8.47682 32.0629H2.77307Z",
    fill: "#0C3798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.16002 26.4375L1.72127 15.4519C1.71254 15.2295 1.61803 15.0192 1.45757 14.865C1.29711 14.7109 1.08317 14.6248 0.860644 14.625C0.747416 14.6243 0.635168 14.646 0.530414 14.689C0.425661 14.732 0.330489 14.7954 0.250424 14.8754C0.170358 14.9555 0.106993 15.0507 0.0640074 15.1554C0.0210217 15.2602 -0.000728773 15.3724 1.86278e-05 15.4856V16.875L0.511894 27.6188C0.526337 27.9073 0.65121 28.1792 0.860643 28.3781C1.07008 28.5771 1.34802 28.6879 1.63689 28.6875H11.8125V26.4375H2.16002Z",
    fill: "#2F79F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.625 15.7504C14.5357 15.75 14.4479 15.7284 14.3686 15.6873C14.2894 15.6462 14.2211 15.5869 14.1693 15.5142L11.3568 11.5767C11.2851 11.4556 11.2614 11.312 11.2904 11.1742C11.3193 11.0365 11.3989 10.9146 11.5133 10.8327C11.6278 10.7508 11.7688 10.7147 11.9085 10.7316C12.0482 10.7486 12.1765 10.8173 12.2681 10.9242L15.0806 14.8617C15.1404 14.9456 15.1759 15.0444 15.1834 15.1472C15.1909 15.25 15.1699 15.3528 15.1229 15.4446C15.0759 15.5363 15.0046 15.6133 14.9168 15.6672C14.829 15.7212 14.728 15.75 14.625 15.7504Z",
    fill: "#EE7231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.5625 12.9375C11.4265 12.9375 12.9375 11.4265 12.9375 9.5625C12.9375 7.69854 11.4265 6.1875 9.5625 6.1875C7.69854 6.1875 6.1875 7.69854 6.1875 9.5625C6.1875 11.4265 7.69854 12.9375 9.5625 12.9375Z",
    fill: "#88B8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.7499 28.0411C33.7276 27.8919 33.6468 27.7577 33.5255 27.668C33.4042 27.5784 33.2523 27.5406 33.1031 27.5629C32.9539 27.5853 32.8197 27.666 32.73 27.7874C32.6404 27.9087 32.6026 28.0606 32.6249 28.2098L32.8781 29.8129H27.8718L28.1249 28.2098C28.1473 28.0606 28.1095 27.9087 28.0199 27.7874C27.9302 27.666 27.796 27.5853 27.6468 27.5629C27.4976 27.5406 27.3457 27.5784 27.2244 27.668C27.1031 27.7577 27.0223 27.8919 26.9999 28.0411L25.8749 35.3536C25.8526 35.5027 25.8904 35.6547 25.98 35.776C26.0697 35.8973 26.2039 35.9781 26.3531 36.0004C26.5023 36.0228 26.6542 35.985 26.7755 35.8953C26.8968 35.8057 26.9776 35.6715 26.9999 35.5223L27.3543 33.1879H33.3956L33.7499 35.5223C33.7723 35.6715 33.853 35.8057 33.9744 35.8953C34.0957 35.985 34.2476 36.0228 34.3968 36.0004C34.546 35.9781 34.6802 35.8973 34.7699 35.776C34.8595 35.6547 34.8973 35.5027 34.8749 35.3536L33.7499 28.0411ZM27.5231 32.0629L27.6974 30.9379H33.0524L33.2268 32.0629H27.5231Z",
    fill: "#0C3798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.84 26.4375L34.2787 15.4519C34.2875 15.2295 34.382 15.0192 34.5424 14.865C34.7029 14.7109 34.9169 14.6248 35.1394 14.625C35.2526 14.6243 35.3649 14.646 35.4696 14.689C35.5744 14.732 35.6695 14.7954 35.7496 14.8754C35.8297 14.9555 35.893 15.0507 35.936 15.1554C35.979 15.2602 36.0007 15.3724 36 15.4856V16.875L35.4881 27.6188C35.4737 27.9073 35.3488 28.1792 35.1394 28.3781C34.9299 28.5771 34.652 28.6879 34.3631 28.6875H24.1875V26.4375H33.84Z",
    fill: "#2F79F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M30.375 12.9375C32.239 12.9375 33.75 11.4265 33.75 9.5625C33.75 7.69854 32.239 6.1875 30.375 6.1875C28.511 6.1875 27 7.69854 27 9.5625C27 11.4265 28.511 12.9375 30.375 12.9375Z",
    fill: "#88B8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.875 24.1875H19.125V34.875H16.875V24.1875Z",
    fill: "#0C3798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M22.5 34.875V36H13.5V34.875H16.3125V33.1875H19.6875V34.875H22.5Z",
    fill: "#2F79F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M14.0625 21.9375C13.1674 21.9375 12.3089 21.5819 11.676 20.949C11.0431 20.3161 10.6875 19.4576 10.6875 18.5625H17.4375C17.4375 19.4576 17.0819 20.3161 16.449 20.949C15.8161 21.5819 14.9576 21.9375 14.0625 21.9375ZM22.5 21.9375C21.6049 21.9375 20.7464 21.5819 20.1135 20.949C19.4806 20.3161 19.125 19.4576 19.125 18.5625H25.875C25.875 19.4576 25.5194 20.3161 24.8865 20.949C24.2536 21.5819 23.3951 21.9375 22.5 21.9375Z",
    fill: "#F8CF6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M14.4506 12.4988C14.3125 12.4453 14.1652 12.4196 14.0171 12.4232C13.8691 12.4268 13.7232 12.4595 13.5878 12.5196C13.4525 12.5797 13.3303 12.666 13.2284 12.7734C13.1264 12.8808 13.0467 13.0073 12.9937 13.1456L11.6269 16.7119L9.71998 15.8288C9.52018 15.1368 9.09125 14.5331 8.50347 14.1168C7.9157 13.7005 7.20394 13.4962 6.48485 13.5374C5.76575 13.5786 5.08198 13.8628 4.54557 14.3435C4.00917 14.8242 3.65196 15.4728 3.53248 16.1831L2.2781 24.0244C2.23098 24.3221 2.24891 24.6265 2.33067 24.9167C2.41243 25.2068 2.55607 25.4758 2.75171 25.7051C2.94736 25.9344 3.19036 26.1186 3.46399 26.2451C3.73763 26.3715 4.03542 26.4372 4.33685 26.4375C8.5106 26.4375 7.14935 26.3756 10.2825 26.6738L10.125 34.8075C10.1071 35.1059 10.2084 35.3991 10.4068 35.6228C10.6051 35.8464 10.8841 35.9821 11.1825 36C11.4808 36.0179 11.7741 35.9166 11.9977 35.7182C12.2214 35.5199 12.3571 35.2409 12.375 34.9425L13.3144 25.38C13.3476 25.0222 13.2469 24.6648 13.0318 24.377C12.8167 24.0892 12.5025 23.8914 12.15 23.8219L9.2756 23.2594L9.64123 19.035L11.9981 19.8338C12.1662 19.8935 12.3449 19.918 12.5229 19.9057C12.7009 19.8934 12.8745 19.8446 13.0328 19.7623C13.1912 19.68 13.3308 19.5659 13.4431 19.4272C13.5554 19.2886 13.638 19.1282 13.6856 18.9563L15.1481 13.815C15.2123 13.5483 15.1769 13.2673 15.0484 13.0249C14.92 12.7825 14.7074 12.5954 14.4506 12.4988Z",
    fill: "#88B8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M21.9374 16.5827C21.8356 16.5824 21.7359 16.5545 21.6487 16.502C21.5615 16.4495 21.4902 16.3744 21.4424 16.2845L19.1924 12.077C19.134 11.947 19.1272 11.7997 19.1733 11.6649C19.2193 11.53 19.3149 11.4176 19.4406 11.3505C19.5663 11.2834 19.7128 11.2665 19.8505 11.3032C19.9882 11.3399 20.1068 11.4275 20.1824 11.5483L22.4324 15.7558C22.478 15.8414 22.5007 15.9373 22.4982 16.0343C22.4958 16.1312 22.4683 16.2259 22.4185 16.3091C22.3687 16.3923 22.2982 16.4612 22.2139 16.5091C22.1296 16.5571 22.0344 16.5824 21.9374 16.5827Z",
    fill: "#EE7231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M30.5889 14.0627C29.9552 14.0637 29.3363 14.2551 28.8127 14.6122C28.2891 14.9693 27.885 15.4755 27.6527 16.0652L25.0652 16.9989L21.6058 13.832C21.3906 13.6477 21.1137 13.5514 20.8306 13.5624C20.5475 13.5733 20.2789 13.6907 20.0785 13.891C19.8782 14.0914 19.7608 14.36 19.7499 14.6431C19.7389 14.9262 19.8352 15.2031 20.0195 15.4183L23.7827 19.5302C23.9352 19.696 24.1294 19.818 24.3451 19.8833C24.5608 19.9486 24.79 19.9548 25.0089 19.9014L27.3208 19.3389L27.1464 23.2145L23.8445 23.8502C23.4917 23.9161 23.1766 24.1124 22.9619 24.4C22.7472 24.6877 22.6486 25.0456 22.6858 25.4027L23.6252 34.9652C23.6431 35.2635 23.7788 35.5426 24.0024 35.7409C24.226 35.9392 24.5193 36.0406 24.8177 36.0227C25.116 36.0048 25.3951 35.8691 25.5934 35.6454C25.7917 35.4218 25.8931 35.1285 25.8752 34.8302L25.7177 26.6964C28.8283 26.3758 27.5233 26.4377 31.5002 26.4377C32.0969 26.4377 32.6692 26.2006 33.0912 25.7787C33.5131 25.3567 33.7502 24.7844 33.7502 24.1877V17.2239C33.7502 16.3855 33.4171 15.5814 32.8243 14.9886C32.2314 14.3957 31.4273 14.0627 30.5889 14.0627Z",
    fill: "#88B8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27 21.9375H9C8.68934 21.9375 8.4375 22.1893 8.4375 22.5V23.625C8.4375 23.9357 8.68934 24.1875 9 24.1875H27C27.3107 24.1875 27.5625 23.9357 27.5625 23.625V22.5C27.5625 22.1893 27.3107 21.9375 27 21.9375Z",
    fill: "#2F79F0"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -83,
    y: -126,
    width: 1361,
    height: 652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -58,
    y: -101,
    width: 1311,
    height: 602,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinnerWithCoach);
export default __webpack_public_path__ + "static/media/dinner_with_coach.a263423a9afee7e96c64fc8502340949.svg";
export { ForwardRef as ReactComponent };